<ng-container *transloco="let t">
    <div class="container-fluid p-0 flex justify-center items-center" style="height: 100%; overflow: auto;">
        <div class="flex justify-center items-center tis-section" style="margin: 0px; width: 750px; max-width: 95%; max-height: 95%;" *ngIf="!loading">
            <div class="grid grid-cols-12 gap-3 w-full">
                <ng-container *ngIf="!isError">
                    <div class="col-span-12 flex justify-center">
                        <div class="qr-image position-relative">
                            <qrcode
                                #qrCode
                                id="qrCode"
                                [qrdata]="permaLinkUrl"
                                [allowEmptyString]="true"
                                [ariaLabel]="'QR Code image with the following content...'"
                                [cssClass]="'tis-qr-code'"
                                [colorDark]="'#000000ff'"
                                [colorLight]="'#ffffffff'"
                                [elementType]="'canvas'"
                                [errorCorrectionLevel]="'M'"
                                [imageSrc]="'./assets/logo/cantrack-logo-with-border.png'"
                                [imageHeight]="68"
                                [imageWidth]="68"
                                [margin]="1"
                                [scale]="1"
                                [title]="'Supplier QR Code'"
                                [width]="300"
                                style="cursor: pointer;"
                                *ngIf="permaLinkUrl"
                                (click)="openQrDialog()"
                            ></qrcode>
                        </div>
                    </div>
                    <div class="col-span-12 py-3">
                        <h3 class="text-center mb-1" style="font-size: 1.75rem;">{{ supplierDetail?.name }}</h3>
                        <p class="text-center mb-0">{{ supplierDetail?.email }}</p>
                        <p class="text-center mb-0">{{ supplierDetail?.address }}</p>
                    </div>
                    <div class="col-span-12">
                        <ul class="p-0 m-0 mb-2 w-full"
                            style="display: inline-flex; justify-content: center;">
                            <li class="p-0 m-0 px-2" style="list-style: none;">
                                <div class="flex items-center" style="gap: 5px;">
                                    <span class="material-icons" style="font-size: 17px;">apartment</span>
                                    <p class="m-0">Verified Supplier For : {{supplierDetail?.org?.organisationName}}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </ng-container>

                <ng-container *ngIf="mode == 'VERIFY'">
                    <div class="col-span-12 border-y py-4" *ngIf="!isError">
                        <h4 class="tis-text-success text-center" style="font-size: 1.5rem;">Congratulation!</h4>
                        <p class="tis-text-success text-center">You have been verified successfully.</p>
                    </div>

                    <div class="col-span-12 border-y py-4" *ngIf="isError">
                        <h4 class="tis-text-danger text-center" style="font-size: 1.5rem;">Oops!</h4>
                        <p class="tis-text-danger text-center">Verification failed.</p>
                    </div>
                </ng-container>

                <ng-container *ngIf="permaLinkUrl">
                    <div class="col-span-12 pt-3">
                        <p class="text-center mb-3"><strong>Your Permanent Cantrak Url:</strong></p>
                        <mat-form-field class="url-input tis-mat-form-field tis-mat-form-field-mb-0 tis-mat-form-field-sm" style="width:100%" appearance="outline">
                            <input matInput #urlInput [value]="permaLinkUrl" readonly>
                            <button mat-button matSuffix [cdkCopyToClipboard]="permaLinkUrl">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="text-center" *ngIf="loading">
            <mat-progress-spinner color="primary" mode="indeterminate" [diameter]="100"></mat-progress-spinner>
            <p class="mt-3">Loading...</p>
        </div>
    </div>
</ng-container>